import { Trophy } from "lucide-react";

const ITEMS = [
  "Treine em alto nível",
  "Jogue em alto nível",
  "Desde 2011",
  "Patos de Minas / MG",
  "SUB 5 ao SUB 15",
  "Treino de goleiro",
  "Alto rendimento",
];

const Row = () => (
  <div className="flex w-max shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="px-6 font-display text-2xl uppercase tracking-widest text-white/90 sm:text-3xl">
          {item}
        </span>
        <Trophy size={18} className="shrink-0 text-gold" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-white/10 bg-royal/40 py-4"
    aria-hidden="true"
  >
    <div className="flex w-max animate-[marquee_42s_linear_infinite]">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
